import AmexShopSmallBanner from './AmexShopSmallBanner';

export default AmexShopSmallBanner;
